module.exports = "<!-- ko template: { name: templateData.name, data: templateData.data } -->\n<!-- /ko -->\n";